<template>
    <form-row title="Are there Roadways to the Site?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="roads_roadways_exist"
                v-model="roads_roadways_exist"
                true="Yes"
                false="No"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        roads_roadways_exist: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
}
</script>
